import { PartialTranslation } from '../translations';

export const ml: PartialTranslation = {
  newChat: 'പുതിയ ചാറ്റ്',
  search: 'തിരയുക',
  user: 'ഉപയോക്താവ്',
  settings: 'ക്രമീകരണങ്ങൾ',
  language: 'ഭാഷ',
  getHelp: 'സഹായം നേടുക',
  viewAllPlans: 'എല്ലാ പ്ലാനുകളും കാണുക',
  learnMore: 'കൂടുതൽ പഠിക്കുക',
  logOut: 'ലോഗ് ഔട്ട്',
  chooseLanguage: 'ഭാഷ തിരഞ്ഞെടുക്കുക',
  chooseYourPreferredLanguage: 'നിങ്ങളുടെ ഇഷ്ടപ്പെട്ട ഭാഷ തിരഞ്ഞെടുക്കുക',
  searchLanguages: 'ഭാഷകൾ തിരയുക...',
  autoDetect: 'സ്വയമേവ കണ്ടെത്തൽ',
  noLanguagesFound: 'ഭാഷകൾ കണ്ടെത്തിയില്ല',
  askAnything: 'എന്തും ചോദിക്കുക',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'വ്യക്തിഗത',
  freePlan: 'സൗജന്യ പ്ലാൻ',
  current: 'നിലവിലുള്ള',
  close: 'അടയ്ക്കുക',
  archive: 'ആർക്കൈവ്',
  delete: 'ഇല്ലാതാക്കുക',
  confirmDelete: 'ഈ ചാറ്റ് ഇല്ലാതാക്കാൻ നിങ്ങൾക്ക് ഉറപ്പാണോ?',
  confirmArchive: 'ഈ ചാറ്റ് ആർക്കൈവ് ചെയ്യാൻ നിങ്ങൾക്ക് ഉറപ്പാണോ?',
  deleteCannotUndo: 'ഈ പ്രവർത്തനം പഴയപടിയാക്കാൻ കഴിയില്ല.',
  archiveCanFind: 'ആർക്കൈവ് ചെയ്ത ശേഷം നിങ്ങൾക്ക് അത് ആർക്കൈവ് പട്ടികയിൽ കണ്ടെത്താം.',
  // 资源面板
  resources: 'വിഭവങ്ങൾ',
  addResource: 'വിഭവം ചേർക്കുക',
  deleteResource: 'വിഭവം ഇല്ലാതാക്കുക',
  noMatchingResourcesFound: 'പൊരുത്തപ്പെടുന്ന വിഭവങ്ങൾ കണ്ടെത്തിയില്ല',
  noResourcesAvailable: 'വിഭവങ്ങൾ ലഭ്യമല്ല',
  hideResources: 'വിഭവങ്ങൾ മറയ്ക്കുക',
  showResources: 'വിഭവങ്ങൾ കാണിക്കുക',
  
  // 聊天输入框
  typeMessage: 'ഒരു സന്ദേശം ടൈപ്പ് ചെയ്യുക...',
  thinkingOptions: 'ചിന്താ ഓപ്ഷനുകൾ',
  deleteFile: 'ഫയൽ ഇല്ലാതാക്കുക',
  clearSelection: 'തിരഞ്ഞെടുപ്പ് ക്ലിയർ ചെയ്യുക',
  
  // 思考模式选项
  deepInsight: 'ആഴത്തിലുള്ള ഉൾക്കാഴ്ച · ഉപരിതല വിശകലനം',
  deepInsightDesc: 'പ്രധാന പോയിന്റുകളുടെ വേഗത്തിലുള്ള ധാരണ',
  deepExploration: 'ആഴത്തിലുള്ള പര്യവേക്ഷണം · സമഗ്ര വിശകലനം',
  deepExplorationDesc: 'ബഹുമാന ആഴത്തിലുള്ള ഗവേഷണം',
  deepDeconstruction: 'ആഴത്തിലുള്ള വിഘടനം · ക്രമാനുഗത വാദം',
  deepDeconstructionDesc: 'പാളി പാളിയായ പുരോഗമന വിശകലനം',
  
  // 写作模式选项
  contractReview: 'കരാർ അവലോകനം · റിസ്ക് തിരിച്ചറിയൽ',
  contractReviewDesc: 'ക്ലോസ് വിശകലനം മറ്റും അനുസരണ പരിശോധന',
  textPolish: 'ടെക്സ്റ്റ് പോളിഷ് · പ്രൊഫഷണൽ എക്സ്പ്രഷൻ',
  textPolishDesc: 'ഭാഷാ ഒപ്റ്റിമൈസേഷനും ഘടന ക്രമീകരണവും',
  legalDocuments: 'നിയമ രേഖകൾ · സ്റ്റാൻഡേർഡ് ഡ്രാഫ്റ്റിംഗ്',
  legalDocumentsDesc: 'പ്രൊഫഷണൽ നിയമ രേഖ എഴുത്ത്',
  addAttachment: 'അറ്റാച്ച്മെന്റ് ചേർക്കുക',
  sendMessage: 'സന്ദേശം അയയ്ക്കുക',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'ലോഗിൻ',
  register: 'രജിസ്റ്റർ',
  welcomeBack: 'LawHelper-ലേക്ക് സ്വാഗതം',
  loginSubtitle: 'നിങ്ങളുടെ AI നിയമ ഗവേഷണ അസിസ്റ്റന്റ്',
  continueWithGoogle: 'Google ഉപയോഗിച്ച് തുടരുക',
  continueWithMicrosoft: 'Microsoft ഉപയോഗിച്ച് തുടരുക',
  continueWithWeChat: 'WeChat ഉപയോഗിച്ച് തുടരുക',
  orContinueWith: 'അല്ലെങ്കിൽ ഇതുപയോഗിച്ച് തുടരുക',
  emailTab: 'ഇമെയിൽ',
  phoneTab: 'ഫോൺ',
  emailPlaceholder: 'നിങ്ങളുടെ ഇമെയിൽ നൽകുക',
  phonePlaceholder: 'ഫോൺ നമ്പർ നൽകുക',
  codePlaceholder: '6 അക്ക കോഡ് നൽകുക',
  sending: 'അയയ്ക്കുന്നു...',
  verifying: 'പരിശോധിക്കുന്നു...',
  verify: 'പരിശോധിക്കുക',
  sendMagicLink: 'മാജിക് ലിങ്ക് അയയ്ക്കുക',
  getVerificationCode: 'കോഡ് നേടുക',
  resendCode: 'കോഡ് വീണ്ടും അയയ്ക്കുക',
  resendIn: 'വീണ്ടും അയയ്ക്കുക',
  magicLinkSent: 'മാജിക് ലിങ്ക് നിങ്ങളുടെ ഇമെയിലിലേക്ക് അയച്ചു',
  magicLinkHint: 'നിങ്ങളുടെ ഇമെയിലിലേക്ക് ഒരു സുരക്ഷിത ലിങ്ക് അയയ്ക്കും',
  otpSent: 'പരിശോധനാ കോഡ് അയച്ചു',
  agreeToTerms: 'തുടരുന്നതിലൂടെ, നിങ്ങൾ സമ്മതിക്കുന്നു',
  privacyPolicy: 'സ്വകാര്യതാ നയം',
  termsOfService: 'സേവന നിബന്ധനകൾ',
  and: 'കൂടാതെ',
  privacyTitle: 'നിങ്ങളുടെ സ്വകാര്യത പ്രധാനമാണ്',
  privacyIntro: 'മികച്ച അനുഭവം നൽകാൻ ഞങ്ങൾ കുക്കികളും സമാന സാങ്കേതികവിദ്യകളും ഉപയോഗിക്കുന്നു.',
  essentialCookies: 'അവശ്യ കുക്കികൾ',
  essentialDesc: 'വെബ്സൈറ്റ് പ്രവർത്തിക്കാൻ ആവശ്യമാണ്',
  analyticsCookies: 'അനലിറ്റിക്സ് കുക്കികൾ',
  analyticsDesc: 'സേവനം മെച്ചപ്പെടുത്താൻ സഹായിക്കുന്നു',
  marketingCookies: 'മാർക്കറ്റിംഗ് കുക്കികൾ',
  marketingDesc: 'വ്യക്തിഗതമാക്കിയ ഉള്ളടക്കത്തിനായി ഉപയോഗിക്കുന്നു',
  acceptAll: 'എല്ലാം സ്വീകരിക്കുക',
  essentialOnly: 'അവശ്യമായവ മാത്രം',
  customize: 'ഇഷ്ടാനുസൃതമാക്കുക',
  savePreferences: 'മുൻഗണനകൾ സംരക്ഷിക്കുക',
  back: 'പിന്നിലേക്ക്',
  readPrivacyPolicy: 'ഞങ്ങളുടെ സ്വകാര്യതാ നയം വായിക്കുക',
  cookiePolicy: 'കുക്കി നയം',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI അവലോകനം',
  aiDraft: 'AI ഡ്രാഫ്റ്റ്',
  smartAssistant: 'ടെംപ്ലേറ്റ്',

  // 知识库搜索
  enableKnowledgeSearch: 'തിരയൽ പ്രവർത്തനക്ഷമമാക്കുക',
  knowledgeSearchDesc: 'AI നിങ്ങളുടെ പ്രമാണങ്ങളിൽ തിരയുന്നു',
  clickToDisable: 'പ്രവർത്തനരഹിതമാക്കുക',
  clickToEnable: 'പ്രവർത്തനക്ഷമമാക്കുക',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Close Resources Panel',
  uploading: 'Uploading %{fileName}...',
  processing: 'Processing %{fileName}...',
  uploadSuccess: '✓ %{fileName} uploaded successfully',
  uploadError: '✗ Upload failed: %{error}',
  quickAnswer: 'ദ്രുത ഉത്തരം',
  quickAnswerDesc: 'Fast response for simple questions',
  cancelRequest: 'രദ്ദാക്കുക',
  library: 'ഗ്രന്ഥശാല',
  filterAll: 'എല്ലാം',
  filterChat: 'Chats',
  filterReview: 'Review',
  filterDraft: 'Draft',
  filterTemplate: 'Template',
  filterForm: 'Form',
  thinking: 'ചിന്തിക്കുന്നു...',
  thinkingProcess: 'Thinking Process',
  analyzingLegalLogic: 'Analyzing legal logic...',
  lawhelperThinking: 'Lawhelper is thinking...',
  serviceError: 'Service Error',
  uploaded: 'Uploaded',
  settingsGeneral: 'സാധാരണ',
  settingsNotifications: 'Notifications',
  settingsAppearance: 'Appearance',
  settingsProfile: 'Profile',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'Color Mode',
  settingsLight: 'Light',
  settingsDark: 'Dark',
  settingsSystem: 'System',
  about: 'കുറിച്ച്',
  reviewTitle: 'Document Review',
  exitReview: 'Exit Review',
  uploadPrompt: 'Upload PDF to start review',
  uploadButton: 'Select File',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'Reviewing...',
  reviewComplete: 'Review Complete',
  issuesFound: 'Found %{count} issues',
  draftTitle: 'Legal Document Drafting',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'Generating...',
  generatedSuccess: '✅ Document generated! You can view and edit in the editor.',
  drafterWelcome: 'Welcome to AI Document Assistant',
  drafterYouCan: 'You can:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'Examples:',
  drafterExampleRental: '"Help me draft a rental agreement"',
  drafterExampleLabor: '"Fill in the labor contract based on template"',
  drafterInputPlaceholder: 'Describe your document needs...',
  drafterThinking: 'Thinking...',
  drafterHistoryTitle: 'History',
  drafterNoHistory: 'No history yet',
  drafterNewChat: 'New Chat',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'Save Document',
  drafterDownload: 'Download Document',
  drafterUndo: 'Undo',
  drafterRedo: 'Redo',
  drafterBold: 'Bold',
  drafterItalic: 'Italic',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'Exit',
  drafterConfirm: 'Confirm',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'AI Workflow',
  workflowRunning: 'Running...',
  workflowReady: 'Ready',
  workflowCompleted: 'Completed',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'Accept Changes',
  rejectChanges: 'Reject Changes',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'Stop',
  restartWorkflow: 'Restart',
  startDrafting: 'Start Drafting',
  interrupt: 'Stop',
  documentSubject: 'Document Subject *',
  documentType: 'Document Type',
  jurisdiction: 'Jurisdiction',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'Contract',
  docTypeAgreement: 'Agreement',
  docTypeNotice: 'Notice',
  docTypeLetter: 'Letter',
  docTypePetition: 'Petition',
  docTypeWill: 'Will',
  docTypePowerOfAttorney: 'Power of Attorney',
  countryChina: 'China',
  countryUSA: 'United States',
  countryGermany: 'Germany',
  countryJapan: 'Japan',
  countryFrance: 'France',
  countryUK: 'United Kingdom',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'സ്മാര്ട്ട് ഡോക്യുമെന്റ് സഹായി',
  smartDocChatTitle: 'AI Document Assistant',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'Select File',
  smartDocOr: 'or',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'പിഴവ്',
  unknownError: 'Unknown error',
  file: 'ഫൈല്',
  loading: 'ലോഡ് ചെയ്യുന്നു...',
  localFolders: 'Local Folders',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'Save',
  renameFile: 'Rename',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'AI വിശകലനം',
};
